import { render, staticRenderFns } from "./TeishutsuBrowse.vue?vue&type=template&id=06551544&scoped=true&"
import script from "./TeishutsuBrowse.vue?vue&type=script&lang=ts&"
export * from "./TeishutsuBrowse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06551544",
  null
  
)

export default component.exports